import React, { CSSProperties } from "react";
import { Text } from "./text";
import { Picker, PickerOption } from "./picker";

interface PickerFormFieldProps {
  label?: string;
  name: string;
  value: string;
  placeholder?: string;
  error?: string | false;
  onChange: (value: string) => void;
  options: PickerOption[];
  disabled?: boolean;
  override?: {
    root?: { style?: CSSProperties };
    view?: { style?: CSSProperties };
    arrow?: { style?: CSSProperties };
  };
}

export function PickerFormField(props: PickerFormFieldProps) {
  const {
    override,
    label,
    placeholder,
    error,
    name,
    value,
    onChange,
    options,
    disabled,
  } = props;

  return (
    <div className="picker-form-field">
      {label && (
        <label htmlFor={name}>
          <Text color="muted">{label}</Text>
        </label>
      )}
      <Picker
        override={{
          root: {
            style: {
              ...override?.root?.style,
            },
          },
          view: {
            style: {
              height: 32,
              borderWidth: 1,
              borderRadius: 5,
              borderStyle: "solid",
              borderColor: error ? "#ff2222" : "#d7d5dd",
              paddingLeft: 8,
              paddingRight: 8,
              ...override?.view?.style,
            },
          },
        }}
        name={name}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
        options={options}
        disabled={disabled}
      />
      {error && (
        <div className="picker-form-field-error">
          <Text color="error">{error}</Text>
        </div>
      )}
    </div>
  );
}
